document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-jingform-link]');
  const drawer = link?.closest('header-drawer');
  if (drawer && typeof drawer.closeMenuDrawer === 'function') {
    drawer.closeMenuDrawer(event, drawer.querySelector('summary'));
    drawer.querySelector('summary').setAttribute('aria-expanded', 'false');
  }
});
